export class TotalJobAlert {
    Id: number;
    UserId: number;
    TotalJobCandidateId : string;
    SearchKeyword : string;
    LocationText : string;
    Email : string;
    EmailConsent : boolean;
    ExternalSubscriptionId : string;
    UnsubscribeUrl : string;
    IsDeletedFromTotalJob : boolean;
}
